// Full list of Basker booking statuses, but only 'onSale' is considered bookable
const BOOKABLE_STATUSES = [
    // 'cancelled',
    // 'comingSoon',
    // 'offSale',
    'onSale',
    // 'soldOut',
    // 'waitlist',

];

export function isBookable(perf) {
    if (BOOKABLE_STATUSES.includes(perf.bookingStatus)) {
        // Basker instance status override
        return true;
    }
    if (perf.booking.bookingLinkURL) {
        // Basker instance booking link override
        return true;
    }
    if (parseInt(perf.tessitura.availability, 10) > 0) {
        // Checking availability of Tessitura performance (null or undefined values are `NaN` so will not trigger)
        return true;
    }
    // Add other 3rd party systems (spektrix, etc.) as needed with additional conditions here
    return false;
}

export function isSchoolBooking(perf) {
    // Will need to add logic, should be based on performance type
    return true;
}
